import React, { useState } from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import FilledInput from '@mui/material/FilledInput'
import { FormControl, FormHelperText } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import Visibility from '@mui/icons-material/Visibility'
import SearchIcon from '@mui/icons-material/Search'

export default function InputText({
  sx,
  label,
  value,
  onChange,
  onBlur,
  type,
  className,
  helperText,
  success,
  variant = 'standard',
  fullWidth = true,
  placeholder = 'digite aqui',
  size = 'medium',
  error = false,
  disabled = false,
  onKeyDown = () => {},
}) {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => setShowPassword(show => !show)

  const handleMouseDownPassword = event => {
    event.preventDefault()
  }

  return (
    <FormControl fullWidth={fullWidth} variant='filled' className={className} sx={[sx]}>
      <InputLabel>{label}</InputLabel>
      <FilledInput
        error={error}
        variant={variant}
        disabled={disabled}
        className={className}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        color={success ? 'success' : 'primary'}
        placeholder={placeholder}
        type={showPassword ? 'text' : type}
        size={size}
        endAdornment={
          type === 'password' ? (
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle password visibility'
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge='end'
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : type === 'search' ? (
            <InputAdornment position='start'>
              <IconButton aria-label='search'>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ) : null
        }
      />

      <FormHelperText
        sx={success ? { color: 'success.main' } : error ? { color: 'error.main' } : {}}
      >
        {helperText}
      </FormHelperText>
    </FormControl>
  )
}
